import React, {useRef, useEffect} from 'react';
import IconFromStyle from '../StockItems/IconFromStyle';

function App(props) {

  var clickFn = props.clickFn
  var addClassNames = props.addClassNames;
  var addCCColWidth = props.addCCColWidth;
  var allStyles = props.allStyles;
  var stylesToAdd = props.stylesToAdd;
  var actHoveringWhere = props.actHoveringWhere;
  var itemInfoPathString = props.itemInfoPathString;
  var itemPath = props.itemPath;
  var doAScreenRef = props.doAScreenRef;

  const ref1 = useRef();

  useEffect(()=>{
    doAScreenRef(ref1, itemPath);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <div onClick={clickFn} ref={ref1} className={addClassNames + addCCColWidth} style={{...allStyles, ...stylesToAdd}} onMouseOver={actHoveringWhere(itemInfoPathString)} onMouseOut={actHoveringWhere('')}><IconFromStyle style={allStyles}/></div>

}
//




export default App;
